import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '@utils/styles';

import breakpoints from '@rsc/ui-components/breakpoints';
import BreadcrumbComponent from '@rsc/ui-components/Breadcrumb';

const BreadcrumbWrapper = styled.div`
  font-size: ${styles.fontSize.sm};
  padding: ${styles.spacing['spacing-md']} ${styles.spacing['spacing-lg']};

  display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'block')};

  @media screen and (min-width: ${breakpoints.lg}) {
    padding: 1.25rem 1.25rem;
  }

  a {
    font-size: ${styles.fontSize.sm};
    font-weight: ${styles.fontWeight.light};
    color: ${styles.colors.gray[600]};
  }

  a:hover {
    text-decoration: underline;
  }

  svg {
    margin: 0 ${styles.spacing['spacing-1xs']};
    width: 5px;
    height: 10px;
    fill: ${styles.colors.gray[300]};
    fill-rule: evenodd;
  }

  span {
    color: ${styles.colors.gray[600]};
    font-weight: ${styles.fontWeight.light};
    text-decoration: none;
  }
`;

const Breadcrumb = ({ elements, hideOnMobile = false }) => (
  <BreadcrumbWrapper hideOnMobile={hideOnMobile}>
    <BreadcrumbComponent elements={elements} useSVG />
  </BreadcrumbWrapper>
);

Breadcrumb.propTypes = {
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  hideOnMobile: PropTypes.bool.isRequired,
};

export default Breadcrumb;
